var tableStyle = { width: '100%', borderSpacing: '2px 0', marginBottom: '2px' };
var firstTdStyle = { width: '6em', textTransform: 'capitalize' };

var PropertyStyle = {
  tableStyle: tableStyle,
  firstTdStyle: firstTdStyle
};

export default PropertyStyle;